export const BUSINESS_INFO = {
  legalName: 'Lumiron KLG',
  displayName: 'Lumiron Bubble Soccer',
  street: 'Kamorstrasse 10',
  postalCode: '9444',
  city: 'Diepoldsau',
  countryCode: 'CH',
  email: 'info@lumiron.ch',
  phoneDisplay: '079 736 17 71',
  phoneE164: '+41797361771',
  uid: 'CHE-410.075.220',
  managers: ['Luca Kuster', 'Mischa Büchel', 'Aaron Zellweger', 'Mario Zünd'],
  cancellationHours: 24,
  damageDirtyChf: 250,
  damageDestroyedChf: 120,
  paymentMethods: ['Cash', 'Bank Transfer'] as const,
  currency: 'CHF',
  social: {
    instagram: 'https://www.instagram.com/lumiron.bubblesoccer/',
    linkedin: 'https://www.linkedin.com/company/lumironklg/',
  },
} as const;
